<!-- 时间组件 -->
<template>
    <div class="block">
        <el-date-picker
            v-model="times[0]"
            type="date"
            format="yyyy-MM-dd"
            :picker-options="beginPickerOptions"
            @change="emit"
            :editable="false"
            :clearable="clearable"
            placeholder="开始时间"
        ></el-date-picker> - 
        <el-date-picker
            v-model="times[1]"
            type="date"
            :picker-options="pickerOptions"
            :editable="false"
            format="yyyy-MM-dd"
            :clearable="clearable"
            @change="emit"
            placeholder="结束时间"
        ></el-date-picker>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // times:[new Date(),new Date()],
                times: ['',''],
                placeholder: ['开始日期', '结束日期'],
            };
        },
        props: {
            clearable: {
                typeof: Boolean,
                default: false
            },
            beginTime: {
            type: String,
            default: null
            },
            endTime: {
            type: String,
            default: null
            },
        },
        components: {},
        computed: {
            beginPickerOptions(){
                return {
                    disabledDate(time){
                        return (
                            time.getTime() > Date.now()
                        )
                    }
                }
            },
            pickerOptions(){ // pickerOptions
                let _this = this;
                return {
                    disabledDate(time){
                        return (
                            time.getTime() > Date.now()
                            // Date.now() < time.getTime() < new Date(_this.times[0]).getTime()
                        )
                    }
                }
            }
        },
        created() {
            if (this.beginTime) {
                this.times = [new Date(this.beginTime), new Date(this.endTime)];
            }
            this.emit();
        },
    
        methods: {
            isEariy(){
                return this.times[0]
            },
            emit() {
                this.pickerOptions
                console.log(this.times[0],this.times[1]);
                if(this.times[0] && this.times[1]){
                    if(this.times[0].getTime() > this.times[1].getTime()){
                        this.$message.warning('开始时间不能大于结束时间');
                    } else {
                        this.$emit('time', this.times)
                    }
                } else {
                    this.$emit('time', this.times)
                }
            },

        }
    }
</script>
<style lang='less' scoped>
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    // width: 220px;
    width: 150px;
}
</style>